import ReVerify from './ReVerify';

export default ReVerify;